module.exports = __webpack_public_path__ + "img/simbologia.ac4b7b24.png";